<template>
	<Card bordered size="large" :loading :content-class="total ? 'p-0!' : undefined" class="overflow-hidden">
		<template #header>
			<div class="flex items-start justify-between gap-4">
				<div class="flex flex-col gap-2">
					<div class="text-fs-base font-medium">{{ $t(`dashboard.total_patients`) }}</div>
					<div v-if="total" class="text-fs-4xl font-bold">{{ total }}</div>
				</div>

				<div v-if="total" class="text-fs-sm text-right font-normal">
					{{ $t(`dashboard.last_30_days_data`) }}
				</div>
			</div>
		</template>

		<VueApexCharts v-if="total" height="190" :options class="-mb-1" :series></VueApexCharts>

		<Card v-else embedded size="small" content-class="flex flex-col gap-4" class="min-h-full">
			<div class="bg-grey-100 flex size-12 items-center justify-center rounded-full">
				<Icon name="carbon:chart-line-smooth" :size="24" />
			</div>
			<div class="text-fs-md text-secondary">
				{{ $t(`dashboard.no_patients_chart_message`) }}
			</div>
		</Card>
	</Card>
</template>

<script lang="ts" setup>
import type { ApexOptions } from "apexcharts"
import type { PatientsTimeline } from "@/types/dashboard"
import { computed } from "vue"
import VueApexCharts from "vue3-apexcharts"
import Card from "@/components/common/Card.vue"
import Icon from "@/components/common/Icon.vue"

const props = defineProps<{
	loading?: boolean
	data?: PatientsTimeline
}>()

const total = computed(() => props?.data?.at(-1)?.total_reg || 0)

const options: ApexOptions = {
	chart: {
		type: "area",
		height: 190,
		sparkline: {
			enabled: true
		}
	},
	stroke: {
		colors: ["var(--primary-color)"],
		curve: "straight",
		width: 2
	},
	fill: {
		type: "gradient",
		gradient: {
			colorStops: [
				{
					offset: 0,
					color: "var(--primary-color)",
					opacity: 0.3
				},
				{
					offset: 100,
					color: "var(--primary-color)",
					opacity: 0
				}
			]
		}
	},
	tooltip: {
		enabled: false
	}
}

const series = computed(() => [
	{
		data: props.data?.map(item => item.total_reg) || []
	}
])
</script>
